

export default function LayaoutMain({children}) {
    return (
        <div className="min-h-screen w-full  flex justify-start items-center flex-col">
            {children}
        </div>
    ) 
}